export default __webpack_public_path__ + "static/media/about-us-photo-geedop-park.b1a05b65.jpg";